import React from "react";

export const SkeletonBar = ({ width, height, className = "" }) => (
  <span
    className={`inline-block rounded animate-pulse bg-grey-100 ${className}`}
    style={width !== undefined || height !== undefined ? { width, height } : undefined}
  />
);

export const DetailFieldSkeleton = () => (
  <div className="flex items-start gap-2.5">
    <SkeletonBar width={24} height={24} className="!rounded-md shrink-0" />
    <div className="flex-1 min-w-0">
      <SkeletonBar width="55%" height={9} className="mb-1.5" />
      <SkeletonBar width="75%" height={14} />
    </div>
  </div>
);

export const ItemDetailsSkeleton = () => (
  <div className="animate-in fade-in">
    <div className="flex items-center gap-2 mb-4">
      <SkeletonBar width="80px" height={12} />
      <SkeletonBar width={24} height={24} className="!rounded" />
    </div>
    <div className="bg-white border border-grey-100 rounded-xl p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map(i => (
          <DetailFieldSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);

export const BoxDetailsSkeleton = () => (
  <div className="animate-in fade-in">
    <div className="flex flex-wrap items-center gap-4 mb-4">
      {[0, 1, 2].map(i => (
        <div key={i} className="flex items-center gap-2">
          <SkeletonBar width={i === 0 ? 88 : 110} height={12} />
          <SkeletonBar width={i === 0 ? 24 : 48} height={i === 0 ? 24 : 14} className={i === 0 ? "!rounded" : ""} />
        </div>
      ))}
    </div>
    <div className="bg-white border border-grey-100 rounded-xl p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[0, 1, 2].map(i => (
          <DetailFieldSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);

export const ServiceRequestsSkeleton = () => (
  <div className="animate-in fade-in flex flex-col gap-4">
    <div className="flex justify-end">
      <SkeletonBar width={128} height={36} className="!rounded-lg" />
    </div>
    <div className="border border-grey-100 rounded-xl overflow-hidden">
      <div className="flex gap-4 px-3 py-3 bg-grey-50 border-b border-grey-100">
        {[0, 1, 2, 3, 4].map(i => (
          <SkeletonBar key={i} width={`${60 + i * 8}px`} height={10} />
        ))}
      </div>
      {[0, 1].map(row => (
        <div
          key={row}
          className="flex gap-4 px-3 py-4 border-b border-grey-100 last:border-b-0">
          {[0, 1, 2, 3, 4].map(i => (
            <SkeletonBar key={i} width={`${50 + i * 10}px`} height={12} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const TrackingContentSkeleton = () => (
  <div className="animate-in fade-in">
    {[0, 1, 2].map(i => (
      <div key={i} className="flex">
        <div className="flex w-5 shrink-0 flex-col items-center">
          <span className="flex h-10 items-center">
            <SkeletonBar width={10} height={10} className="!rounded-full" />
          </span>
          {i < 2 && <span className="w-px flex-1 bg-grey-100" />}
        </div>
        <div className={`flex flex-1 gap-3 ${i < 2 ? "pb-5" : ""}`}>
          <SkeletonBar width={40} height={40} className="!rounded-lg shrink-0" />
          <div className="flex-1 min-w-0 space-y-2 pt-2">
            <SkeletonBar width="40%" height={16} />
            <SkeletonBar width="55%" height={16} />
            <SkeletonBar width="35%" height={16} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const AccordionCardSkeleton = ({ contentRows = 2 }) => (
  <div className="bg-white border border-grey-100 rounded-2xl overflow-hidden mb-4">
    <div className="flex items-center px-4 py-3">
      <SkeletonBar width={32} height={32} className="!rounded-lg shrink-0 mr-3" />
      <SkeletonBar width="160px" height={16} />
      <span className="flex-1 h-px bg-grey-100 mx-3" />
      <SkeletonBar width={32} height={32} className="!rounded-md shrink-0" />
    </div>
    <div className="px-4 pb-4 pt-3 border-t border-grey-100">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: contentRows }).map((_, i) => (
          <DetailFieldSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);
